
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-54568d8c&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SmsSetting.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SmsSetting.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-54568d8c!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SmsSetting.vue"),
  /* scopeId */
  "data-v-54568d8c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/master/company/SmsSetting.vue
// module id = 775
// module chunks = 0